import { createBrowserRouter } from "react-router-dom";
import { wrapCreateBrowserRouterV7 } from "@sentry/react";

import { protectedLoader } from "./authLoaders";

import type { IRoleEnum } from "@/interfaces";
import { layoutRoutes } from "@routes/layoutRoutes.ts";
import {
  getOutsideLayoutRoutes,
  getRoleRoutes,
} from "@routes/getRoleRoutes.ts";
import { outsideRoutes } from "@routes/outsideRoutes.ts";
import { ErrorPage } from "@pages/error/page";

const sentryCreateBrowserRouter =
  wrapCreateBrowserRouterV7(createBrowserRouter);

export const getRouter = (role: IRoleEnum | null) => {
  return sentryCreateBrowserRouter([
    {
      path: "/",
      lazy: () => import("@pages/rootPage/page"),
      children: [
        ...outsideRoutes,
        {
          lazy: () => import("@pages/layout/page"),
          children: getOutsideLayoutRoutes(layoutRoutes),
        },
        {
          lazy: () => import("@pages/layout/page"),
          children: getRoleRoutes(role, layoutRoutes),
          loader: protectedLoader,
        },
      ],
      errorElement: <ErrorPage />,
    },
  ]);
};
